import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import {FileAttachment, FileAttachmentsV1Service} from "../../../apis/backend";

@Component({
    selector: 'file-attachment-list',
    templateUrl: 'file-attachment-list.component.html'
})
export class FileAttachmentListComponent {
    
    @Input('FileList')
    public FileList: FileAttachment[];
    
    @Input('EditMode')
    public EditMode: boolean;

    @Input('UploadHandler')
    public UploadHandler: (file: File) => Promise<FileAttachment>;
    
    @Input('DeleteHandler')
    public DeleteHandler: (file: FileAttachment) => Promise<any>;
    
    constructor() {}
    
    public FileUploader() {
        return (file: File) => {
            return this.UploadHandler(file)
                .then(fileAttachment => {
                    this.FileList.push(fileAttachment);
                });
        }
    }
    
    public DeleteFile(fileAttachment: FileAttachment) {
        this.DeleteHandler(fileAttachment)
            .then(() => {
                let index = this.FileList.findIndex(fa => fa.FileAttachmentID = fileAttachment.FileAttachmentID);
                if (index !== -1) {
                    this.FileList.splice(index, 1);
                }
            });
    }
}